import { render, staticRenderFns } from "./SupplierGalleryItems.vue?vue&type=template&id=fcaa297a&"
import script from "./SupplierGalleryItems.vue?vue&type=script&lang=js&"
export * from "./SupplierGalleryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports